export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID?.trim();
export const AUTH_PROVIDER = {
  EMAIL: 'Email',
  GOOGLE: 'Google',
};

export function decodeGoogleCredential(credential) {
  const payload = credential?.split('.')?.[1];
  if (!payload) {
    return null;
  }

  try {
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((char) => `%${(`00${char.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Unable to read Google credential', error);
    return null;
  }
}

export function getGoogleProfile(credentialResponse) {
  const profile = decodeGoogleCredential(credentialResponse?.credential);
  if (!profile?.email) {
    return null;
  }

  const nameParts = (profile.name || '').trim().split(/\s+/).filter(Boolean);
  const emailPrefix = profile.email.split('@')[0];

  return {
    credential: credentialResponse.credential,
    googleId: profile.sub,
    email: profile.email,
    firstname: profile.given_name || nameParts[0] || emailPrefix,
    lastname: profile.family_name || nameParts.slice(1).join(' ') || '',
    username: emailPrefix,
  };
}

export function createGooglePassword(email, googleId) {
  const raw = `${email}:${googleId || ''}`;
  const encoded = btoa(unescape(encodeURIComponent(raw))).replace(/[^a-zA-Z0-9]/g, '');
  return `G_${encoded.slice(0, 12)}!`;
}

export function getAuthProvider(user) {
  return (
    user?.AuthProvider ||
    user?.AuthenticationProvider ||
    user?.SignupProvider ||
    user?.SignupType ||
    user?.LoginType ||
    user?.RegistrationType ||
    user?.Provider ||
    user?.AccountProvider ||
    ''
  ).toString().toLowerCase();
}

export function isGoogleAccount(user) {
  return getAuthProvider(user).includes('google');
}